var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.22207,
    y: 5.1,
    width: 16.8,
    height: 13.8,
    rx: 1.4,
    stroke: "rgb(166, 134, 237)",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3221 11.8268C15.4554 11.9038 15.4554 12.0962 15.3221 12.1732L11.4221 14.4249C11.2887 14.5019 11.1221 14.4056 11.1221 14.2517L11.1221 9.74833C11.1221 9.59437 11.2887 9.49815 11.4221 9.57513L15.3221 11.8268Z",
    fill: "rgb(166, 134, 237)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIcon);
export default __webpack_public_path__ + "static/media/versionIcon.4346d3b2e59fc5263750dd5b86a8558e.svg";
export { ForwardRef as ReactComponent };